import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
import SubscribeToUnlockTooltip from '../../_partials/SubscribeToUnlockTooltip';
export var BuyButton = function (_a) {
    var _b = _a.deviation, deviationId = _b.deviationId, _c = _b.print, _d = _c === void 0 ? {} : _c, lowestPrice = _d.lowestPrice, purchaseUrl = _d.purchaseUrl, deviation = _a.deviation, className = _a.className;
    var t = useTranslation().t;
    var _e = useSubscriptionTier(deviation), isBlockedBySubscription = _e.isBlockedBySubscription, tierCheckoutUrl = _e.tierCheckoutUrl;
    var button = (React.createElement(ActionBarB18Link
    // seems like this should be isDisabled if isBlockedBySubscription
    , { 
        // seems like this should be isDisabled if isBlockedBySubscription
        href: isBlockedBySubscription ? tierCheckoutUrl : purchaseUrl, biData: {
            evid: BiEventType.BUY_CLICK,
            deviationid: deviationId,
        } }, lowestPrice
        ? t('actionbar.buyFor', { price: lowestPrice })
        : t('actionbar.buy')));
    return isBlockedBySubscription ? (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation }, button)) : (React.createElement(ActionBarItemWrapper, { className: className }, button));
};
BuyButton.displayName = 'BuyButton';
export default BuyButton;
//# sourceMappingURL=BuyButton.js.map